
import { ErrorsTranslationType } from "../../features/errors.types";

export const errors: ErrorsTranslationType = {
  errors: {
    error: "Error",
    notFound: "Página no encontrada",
    deleteAccountError: "Error al eliminar la cuenta",
    loadStoryError: "Error al cargar la historia",
    loadCharactersError: "Error al cargar los personajes",
    summaryError: "Error al generar el resumen"
  }
};
